
































































































import axios from 'axios';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Navigation, FeedbackDialog } from '../components';
import { ToolBar } from '../../core/containers';
import { Footer, AutocompleteVehicles, FilterDate, MultipleSelectVehicle } from '../../core/components';
import {
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    AuthStoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import SpotlightVehicles from '../../core/components/FilterVehicles/SpotlightVehicles.vue';
import SelectCompany from '../../core/components/SelectCompany.vue';
import { Company, VariablesResponse, Privileges, TypeFilterDate } from '../../core/models';
import {
    FilterDateEvent,
    FetchCompanyResponse,
    isEmptyObject,
    sortObjectByPropertyName,
    getValuesFromObject,
    convertDictionaryToList,
    addItemToLocalStorage,
    StoregeKey,
    getItemFromLocalStorage,
    existKeyInLocalStorage,
    getIndexFromList,
    getIndexFromSimpleList,
    ID,
    removeItemFromLocalStorage,
    pageWasVisitedBefore
} from '../../core/utils';
import { getCookie, setCookie, removeCookie } from 'tiny-cookie';
import { SettingsService } from '../../settings/api/SettingsService';
import { NormsServices } from '../../norms/api/NormsServices';
import { InsuranceServices } from '../../insurance/api/InsuranceServices';
import { EventBus, hasElements, TypeEventBus, PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils';
import { JourneysService } from '../../journeys/api/JourneysService';
import { UserService } from '../../core/api';
import { CompanyMap } from '../../../store/types';
import { Vehicle } from '../../settings/models/Vehicle';
import { companyIsSuspended, currentUserIsSmartway, noCompaniesAvailable, noCompaniesMsg } from '../../core/helpers';
import { CompaniesEvent } from '../../../store';
import $ from 'jquery';
import ChatbotWrapper from '../../chatbot/components/ChatbotWrapper.vue';
@Component({
    components: {
        SelectCompany,
        SpotlightVehicles,
        AutocompleteVehicles,
        Navigation,
        ToolBar,
        Footer,
        FilterDate,
        MultipleSelectVehicle,
        FeedbackDialog,
        ChatbotWrapper
    }
})
export default class HomePage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    drawer: boolean = false;
    showFeedbackDialog: boolean = false;
    cancelToken: any | null = null;


    get chatbotWrapperWidth() {
        let base = 'main-container--chat-wrapper pa-0';
        if(this.$_getChatbotIsOpened){
            return `${base} col-sm-4 col-lg-3 col-xl-2`;
        }
        return base
    }


    handleShowFeedbackDialog() {
        this.showFeedbackDialog = true;
    }
    handleCloseFeedbackDialog() {
        this.showFeedbackDialog = false;
    }

    handleShowAndHide(value: boolean) {
        if (value) {
            this.$_openSpotlightVehicles();
        } else {
            this.$_closeSpotlightVehicles();
        }
    }
    handleSelectCompany(company: Company) {
        this.$_selectCompany(company.id);
        this.handleFilterSpotlightVehicles('');
    }

    handleFilterSpotlightVehicles(query: string) {
        this.$_changeQuery(query);
        /*this.$_filterSpotlight(query, this.$_match);*/
    }

    handleUpdateTypeFilterDate(filterDateEvent: FilterDateEvent) {
        if (filterDateEvent) {
            this.$_setTypeFilterDate(filterDateEvent.typeFilterDate);
            if (filterDateEvent.range) {
                this.$_setDateRange(filterDateEvent.range);
            }
        }
    }

    handleSearchCompany(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    fetchVariables(callBack?: Function): void {
        //   this.$_pendingFetchVariablesRequest();
        this.$_fetchVariables(this.$_getSelectedCompanyById as ID)
            .then((result: VariablesResponse) => {
                this.$_setVariables(result);
                if(!pageWasVisitedBefore()){
                    addItemToLocalStorage(StoregeKey.ALREADY_VISITED, true)
                }
                if (callBack) {
                    callBack();
                }
                //  this.$_completeFetchVariablesRequest();
            })
            .catch(error => {
                // this.$_showHistoricalError(error.message);
                //   this.$_completeFetchVariablesRequest();
                this.$_setVariables(null);
            });
    }

    handlePrivileges(privileges: Privileges) {
        let updatedPrivileges = privileges;

        if(privileges.performance_insurance_carrier_limited){
            updatedPrivileges.performance_insurance_carrier = true;
        }
        this.$_setPrivileges(updatedPrivileges)
    }

    initCompaniesAndVariables(): void {
        this.$_showVehiclesFilter();
        this.$_pendingFetchCompaniesRequest();

        this.$_fetchPrivileges(this.$_isMock).then((response: Privileges) => {
            // response.mdp = true;
            // response.journey_only_view = false;
            this.handlePrivileges(response);
            this.getNormsData();
            this.getInsuranceProperties();
            this.$_fetchCompanies(this.$_isMock)
                .then((response: FetchCompanyResponse) => {
                    addItemToLocalStorage(StoregeKey.USER_DEBT, response.debt)
                    EventBus.$emit(TypeEventBus.USER_DOUBT);
                    this.getUserCustomizationSettings();
                    if (!isEmptyObject(response.companies)) {
                        this.$_setVehicles(response.vehicles);
                        this.$_setCompanies(response.companies);
                        this.preselectCompanyFromStorage(response.companies);
                        this.fetchVariables(() => {
                            this.$_completeFetchCompaniesRequest()
                        });
                    } else {
                        this.$_completeFetchCompaniesRequest();
                        //this.shouldNoCompaniesDialogDisplayed = true;
                        this.$_catchLoadingDialog({
                            response: {message: noCompaniesMsg},
                            alternative_msg: noCompaniesMsg
                        })
                    }
                })
                .catch(error => {
                    this.$_completeFetchCompaniesRequest();
                    this.$_closeSession();
                    // console.log("error['message']", error['message']);
                    if (error['message']) {
                        // this.$_showFetchCompaniesError(error['message']);
                    } else {
                        this.$_showFetchCompaniesError('Error obteniendo compañias. Consulte a su administrador');
                    }
                });
        });
    }

    getUserCustomizationSettings() {
        UserService.getUserCustomization()
            .then(res => {
                if (res && res['data']) {
                    this.$_setUserCustomization(res['data']);
                }
            })
            .catch(error => {
                // console.log('no se pudo obtener la configuracion del usuario', error);
            });
    }

    created(){
        $('body').css('overflow', '')
    }

    mounted() {
        
        this.queryParams();
        this.makeDialogsDraggable();
        this.initCompaniesAndVariables();
        EventBus.$on(TypeEventBus.CALL_COMPANIES_ON_HOME_PAGE, () => {
            this.initCompaniesAndVariables();
        });
        EventBus.$on(CompaniesEvent.SET_NO_COMPANIES_AVAILABLE, (msg: string) => {
            if(!pageWasVisitedBefore() && !currentUserIsSmartway()){
                this.$_showHistoricalError(msg)
            }
        });
    }


    preselectCompanyFromStorage(userCompanies: CompanyMap) {
        let self = this;
        let userCompaniesResponse: Array<Company> = Object.values(userCompanies);
        //get urlParams
        const urlParams = new URLSearchParams(window.location.search);
        const urlHasParams = window.location.href.indexOf('?c_id') !== -1 ? true : false;
        let companyLocalStorage: Company | null = existKeyInLocalStorage(StoregeKey.COMPANY) ? JSON.parse(getItemFromLocalStorage(StoregeKey.COMPANY) || '{}') : null;
        let companyIdSaved:ID = -1;

            //si no hay parametros
            if (!urlHasParams) {
                // console.log("no hay parametros");
                if(companyLocalStorage !== null){
                    //si existe empresa guardada en localstorage
                    //actualizo el id de la compañía
                    companyIdSaved = companyLocalStorage['id'];
                    //busco el indice de la empresa para seleccionarla
                    this.tryToSelectCompany(userCompaniesResponse, companyIdSaved)
                }else{
                    this.$_selectFirstCompany();
                }
                //preselecciono el filtro "Ahora"
                this.$_setTypeFilterDate(TypeFilterDate.TR);
            } else {
                // console.log("----hay parametros----");
                //actualizo el id de la empresa por la de los parámetros
                companyIdSaved = Number(urlParams.get('c_id'));
                //me fijo si la empresa esta suspendida
                this.tryToSelectCompany(userCompaniesResponse, companyIdSaved)

                if(
                    companyIdSaved !== -1 && 
                    this.userCanSeeParameters(companyIdSaved)
                ){
                    setTimeout(() => {
                    //preselecciono los vehiculos
                    let vehiclesParams = urlParams.get('v_id');
                    let vehiclesIds:string[] | null = vehiclesParams !== null ? vehiclesParams.split(',') : null;
                    if(companyIdSaved !== -1 && vehiclesIds !== null){
                        //si existe una empresa y vehiculos para seleccionar
                        //busco el indice de la empresa en la lista de compañías
                        let indexCompany = getIndexFromList(userCompaniesResponse, 'id', companyIdSaved);
                        let companyVehicles:ID[] = userCompaniesResponse[indexCompany]['vehicles']; //ids vehiculos de la empresa
                        let correctVehicles: number[] = []; //vehiculos que pertenecen a la empresa
                        let invalidVehicles: number[] = []; //vehiculos que NO pertenecen a la empresa

                        //recorro los vehiculos de la empresa y me fijo cual existe en la Empresa y cual NO
                        for (let index = 0; index < vehiclesIds.length; index++) {
                            const vehicleId = Number(vehiclesIds[index]);
                            let indexVehicleInVehiclesCompany = companyVehicles.findIndex(vehId => vehId == vehicleId);
                            if (indexVehicleInVehiclesCompany !== -1) {
                                //vehiculo existe en la empresa
                                correctVehicles.push(vehicleId);
                            } else {
                                //vehiculo NO existe en la empresa
                                invalidVehicles.push(vehicleId);
                            }
                        }
                        //notifico al usuario si hay vehiculos invalidos en los parámetros
                        this.notifyUserInvalidVehicles(invalidVehicles) 

                        //pre-selecciono los vehiculos validos
                            // console.log("pre-selecciono los vehiculos", correctVehicles);
                            self.$_setSelectedVehicles(correctVehicles);
                            EventBus.$emit(TypeEventBus.FILTER_VEHICLES_CLOSE, vehiclesIds.map(function(vehicle){
                                return {
                                        id:vehicle
                                    }
                                })
                            ); 
                            //actualizo rango de fechas y triggereo la busqueda
                            self.changeRangeDate(urlParams, urlHasParams)
                    }
                }, 500)
                }else{
                    this.$_selectFirstCompany();
                }
            }
        
    }

    userCanSeeParameters(companyIdSaved):boolean{
        let companyFromParameterIsInUserCompanies = this.$store.state.companies[companyIdSaved] !== undefined;

        if(!companyFromParameterIsInUserCompanies){
            alert(`No tiene autorizacion para ver este recorrido.`);
            return false
        }

        let companySuspended = companyIsSuspended(this.$store.state.companies, companyIdSaved);
        //si el usuario es smartway puede ver los parametros
        if(currentUserIsSmartway()){
            return true
        }
        //si el usuario NO es smartway y la empresa esta suspendida no puede ver nada
        if(!currentUserIsSmartway() && companySuspended){
            alert(`La empresa ${this.$store.state.companies[companyIdSaved]['name']} se encuentra suspendida`);
            removeItemFromLocalStorage(StoregeKey.COMPANY)
            return false
        }
        return true
    }

    tryToSelectCompany(userCompaniesResponse:  Array<Company>, companyId: ID):void{
        let indexSavedCompany = getIndexFromList(userCompaniesResponse, 'id', companyId)
        if(indexSavedCompany !== -1){
            this.$_selectCompanyByIndex(indexSavedCompany);
        }
    }



    notifyUserInvalidVehicles(invalidVehicles: ID[]){
        if (invalidVehicles.length > 0 && this.$route.name === 'travel') {
            if (invalidVehicles.length == 1) {
                this.$_showLoginError(
                    'El vehículo [' + invalidVehicles.toString() + '] No pertenece a esta compañía'
                );
            } else {
                this.$_showLoginError(
                    'Los vehículos [' + invalidVehicles.toString() + '] No pertenecen a esta compañía'
                );
            }
        } 
    }

    changeRangeDate(urlParams, urlHasParams) {
        let start_date: string = '';
        let end_date: string = '';

        if (urlHasParams) {
            start_date = urlParams.get('date_start') !== null ? urlParams.get('date_start') : '';
            end_date = urlParams.get('date_end') !== null ? urlParams.get('date_end') : '';
        }

        this.$_setDateRange({
            datetime_from: start_date,
            datetime_to: end_date
        });

        setTimeout(() => {
            EventBus.$emit(TypeEventBus.CLOSE_DATEPICKER_POPUP);
            EventBus.$emit(TypeEventBus.APPLY_RANGE_DATE);
        }, 0)
    }

    getNormsData() {
        if (this.shouldCreateAndReadNorms) {
            NormsServices.getProperties(axios.CancelToken.source())
                .then(response => {
                    let parsedCategories = getValuesFromObject(response['all_categories_flag']);

                    for (let i = 0; i < parsedCategories.length; i++) {
                        parsedCategories[i]['id'] = i;
                    }
                    let filteredCategories = parsedCategories.filter(cat => cat['show_in_web'] == true);
                    filteredCategories = filteredCategories.sort(sortObjectByPropertyName('description'));
                    response['all_categories_flag'] = filteredCategories;
                    
                    this.$_setNormsProperties(response);
                })
                .catch(error => {});
        }
    }

    getInsuranceProperties() {
        if (this.shouldCreateAndReadInsurances) {
            InsuranceServices.getProperties(axios.CancelToken.source())
                .then(res => {                 
                    this.$set(res, 'closing_conditions_options', convertDictionaryToList(res['closing_conditions']));
                    this.$set(res, 'ranch_states', convertDictionaryToList(res['ranch_states']));
                    this.$set(res, 'closing_conditions', res['closing_conditions']);
                    this.$set(res, 'calibration_type_number', convertDictionaryToList(res['calibration_type_number']));
                    this.$set(res, 'calibration_functions', convertDictionaryToList(res['calibration_functions']));
                    this.$set(
                        res,
                        'calibration_type_easy_desc',
                        convertDictionaryToList(res['calibration_type_easy_desc'])
                    );
                    this.$set(res, 'alert_types', convertDictionaryToList(res['alert_types']));
                    this.$set(res, 'sensor_states', convertDictionaryToList(res['sensor_states']));
                    this.$set(res, 'harvest_type', convertDictionaryToList(res['harvest_type']));
                    this.$set(res, 'geometry_export_formats', convertDictionaryToList(res['geometry_export_formats']));
                    this.$set(res, 'performance_units', convertDictionaryToList(res['performance_units']));
                    this.$set(res, 'note_types', convertDictionaryToList(res['note_types']));
                    this.$set(
                        res,
                        'harvest_calculation_phases',
                        convertDictionaryToList(res['harvest_calculation_phases'])
                    );
                    this.$set(
                        res,
                        'harvest_calculation_process',
                        convertDictionaryToList(res['harvest_calculation_process'])
                    );
                    this.$set(
                        res,
                        'sowing_calculation_phases',
                        convertDictionaryToList(res['sowing_calculation_phases'])
                    );
                    this.$set(
                        res,
                        'sowing_classification_phases',
                        convertDictionaryToList(res['sowing_classification_phases'])
                    );
                    this.$set(
                        res,
                        'alert_subscription_types',
                        convertDictionaryToList(res['alert_subscription_types'])
                    );
                    this.$set(
                        res,
                        'seed_groups',
                        convertDictionaryToList(res['seed_groups'])
                    );
                     this.$_setInsuranceProperties(res);
                })
                .catch(error => {});
        }
    }

   
    get shouldCreateAndReadNorms(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.READ)
        );
    }

    get shouldCreateAndReadInsurances(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.INSURANCE, PRIVILEGE_TYPES.EDIT_AND_DELETE) ||
            this.$_checkPrivileges(PRIVILEGE_KEYS.INSURANCE, PRIVILEGE_TYPES.CREATE)
        );
    }
    
    get showClassNotNow(){
        return this.$_getFilterDate !== TypeFilterDate.TR && this.$_getSelectedVehiclesByID.length > 0 && this.$route.name === 'travel' ? true : false
    }

    convertDictionaryToList(obj) {
        let items: any = [];
        for (let i = 0; i < Object.keys(obj).length; i++) {
            items.push({
                id: Object.keys(obj)[i],
                value: Object.values(obj)[i]
            });
        }
        items.sort(sortObjectByPropertyName('value'));
        return items;
    }

    queryParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlHasParams = window.location.href.indexOf('?') !== -1 ? true : false;
        this.$_setQueryParams({
            companyId: {
                id: null
            },
            vehicleId: '',
            datetime_from: '',
            datetime_to: '',
            hasParams: urlHasParams
        });
    }

    makeDialogsDraggable() {
        (function() {
            const d: any = {};
            document.addEventListener('mousedown', e => {
                let evTarget: any = e.target;
                const closestDialog = evTarget.closest('.v-dialog.v-dialog--active');
                if (e.button === 0 && closestDialog != null && evTarget.classList.contains('v-toolbar__content')) {
                    // element which can be used to move element
                    d.el = closestDialog; // element which should be moved
                    d.mouseStartX = e.clientX;
                    d.mouseStartY = e.clientY;
                    d.elStartX = d.el.getBoundingClientRect().left;
                    d.elStartY = d.el.getBoundingClientRect().top;
                    d.el.style.position = 'fixed';
                    d.el.style.margin = 0;
                    d.oldTransition = d.el.style.transition;
                    d.el.style.transition = 'none';
                }
            });
            document.addEventListener('mousemove', e => {
                if (d.el === undefined) return;
                d.el.style.left =
                    Math.min(
                        Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
                        window.innerWidth - d.el.getBoundingClientRect().width
                    ) + 'px';
                d.el.style.top =
                    Math.min(
                        Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
                        window.innerHeight - d.el.getBoundingClientRect().height
                    ) + 'px';
            });
            document.addEventListener('mouseup', () => {
                if (d.el === undefined) return;
                d.el.style.transition = d.oldTransition;
                d.el = undefined;
            });
            setInterval(() => {
                // prevent out of bounds
                const dialog: any = document.querySelector('.v-dialog.v-dialog--active');
                if (dialog === null) return;
                dialog.style.left =
                    Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) +
                    'px';
                dialog.style.top =
                    Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) +
                    'px';
            }, 100);
        })();
    }

    get shouldSeeFilterDate(): boolean{
        return this.$_getIsFilterVehiclesVisible && 
               this.$_getExistVehiclesFromCompanySelected && 
               this.$_getPrivileges[PRIVILEGE_KEYS.ONLY_LAST_REPORT] == PRIVILEGE_TYPES.NONE
    }
}
